import {CHAT_COMPLIANCE} from '@constants/internal-route.constant'
import {ChatComplianceService} from '@services/api/chat.service'
import {usePermissions} from '@services/helper/permission.helper'
import {useQuery} from '@tanstack/react-query'

/**
 * May this person open the conversation review? Only a COMPANY_ADMIN who also holds the explicit
 * CHAT_COMPLIANCE grant. The console's usual check cannot answer that (it lets an admin through
 * everything), so the server is asked: GET /compliance/access answers 200 or the usual 403. Never
 * asked for anyone else.
 */
export const useComplianceAccess = () => {
  const {isSuperAdmin, features} = usePermissions()
  const q = useQuery(
    ['chat-compliance-access'],
    () => ChatComplianceService.access().then((r) => !!r?.body?.allowed),
    {enabled: isSuperAdmin, retry: false, staleTime: 5 * 60_000, refetchOnWindowFocus: false}
  )
  const allowed = isSuperAdmin && q.data === true
  // Placing or releasing a legal hold needs Update on the grant itself (the server checks it too).
  const grant = features.find((f) => f?.url === CHAT_COMPLIANCE)
  const canHold = allowed && Number(grant?.canUpdate) === 1
  return {allowed, canHold, checking: isSuperAdmin && q.isLoading}
}
